import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
// import { Button } from 'antd';
// import { useRequest } from 'ahooks';
import { RootState } from '@/models';
// import { ConBrandWebController } from '@/services/swagger/ConBrandWebController';
import TooltipBase from '@/components/tooltip';
import ChartHeader from '../chart-header';
import Chart from '../chart';
import InfoCard from '../InfoCard';
// import LockedCard, { LockCardState } from '../LockedCard';
// import SupplyInfoContent from '../SupplyInfoContent';
import styles from './index.module.scss';
// import InvestorScore from 'pages/brand/[id]/components/investorScore';

// const controller = new ConBrandWebController();

export type SupplyChainManagementAbilityProps = {
  /** 品牌id */
  conBrandId: string;
  /** 是否品牌认证方 */
  isBrandVendor?: boolean;
  /** 物流配送效率 */
  dsrValue?: string;
  /** 品牌解锁状态 */
  brandLockState?: string;
  /** 品牌解锁状态改变回调 */
  onLockedCardStateChange?: (state: string) => void;
};

const SupplyChainManagementAbility: React.FC<SupplyChainManagementAbilityProps> = ({
  // conBrandId,
  // isBrandVendor,
  // brandLockState = 'not_member',
  dsrValue = '',
  // onLockedCardStateChange,
}) => {
  /** 供应链管理能力：供应链完善度（自主生产能力、仓储能力） */
  // const { data: supplyChain } = useRequest(
  //   async () => {
  //     const res = await controller.conBrandWebControllerV1SupplyChainUsingGet1({
  //       conBrandId,
  //     });
  //     return res.data.data;
  //   },
  //   {
  //     refreshDeps: [isBrandVendor, brandLockState],
  //   }
  // );
  // const productionAbilityLockCardState = useMemo(
  //   () => (isBrandVendor && !supplyChain?.selfFactoryNum ? 'empty' : brandLockState),
  //   [brandLockState, isBrandVendor, supplyChain?.selfFactoryNum]
  // );
  // const storeAbilityLockCardState = useMemo(
  //   () => (isBrandVendor && !supplyChain?.storeNum ? 'empty' : brandLockState),
  //   [brandLockState, isBrandVendor, supplyChain?.storeNum]
  // );
  const { token } = useSelector((state: RootState) => state.user);
  // const onStateChange = useCallback(
  //   (state: string) => {
  //     onLockedCardStateChange?.(state);
  //   },
  //   [onLockedCardStateChange]
  // );
  // const dispatch = useDispatch();
  // const onSupplyInfoBtnClick = useCallback(() => {
  //   dispatch({
  //     type: 'modal/open',
  //     payload: {
  //       content: <SupplyInfoContent conBrandId={conBrandId} defaultActiveKey="supplyChain" />,
  //       title: '补充信息',
  //     },
  //   });
  // }, [conBrandId, dispatch]);
  // const onCoreTeamRateBtnClick = useCallback(() => {
  //   dispatch({
  //     type: 'modal/open',
  //     payload: {
  //       content: <InvestorScore conBrandId={conBrandId} showSupplyChainScore />,
  //       title: '投资人评分',
  //     },
  //   });
  // }, [conBrandId, dispatch]);
  return (
    !!token && (
      <>
        <ChartHeader
          title={
            <h1>
              供应链管理能力
              <TooltipBase title="由供应链完善度、物流配送效率等维度搭建的数学模型计算得出。" placement="right" />
            </h1>
          }
          className={styles.supplyChainChartHeader}
        />
        <div className={styles.chartContainer}>
          {/*<Chart*/}
          {/*  title={*/}
          {/*    <h2 className={styles.chartTitle}>*/}
          {/*      供应链完善度*/}
          {/*      <TooltipBase*/}
          {/*        title={*/}
          {/*          <>*/}
          {/*            <p>自主生产能力指品牌自建工厂数。</p>*/}
          {/*            <p>数据来源：CBNData数据库、品牌提供</p>*/}
          {/*            <p>仓储能力指仓库面积。</p>*/}
          {/*            <p>数据来源：CBNData数据库、品牌提供</p>*/}
          {/*          </>*/}
          {/*        }*/}
          {/*        placement="right"*/}
          {/*      />*/}
          {/*    </h2>*/}
          {/*  }*/}
          {/*  panelClassName={styles.supplyChart}*/}
          {/*  className={styles.chartHeader}*/}
          {/*  extra={*/}
          {/*    <Button type="link" onClick={onCoreTeamRateBtnClick}>*/}
          {/*      <svg*/}
          {/*        className={classnames('icon', styles.rateIcon)}*/}
          {/*        width="13"*/}
          {/*        height="13"*/}
          {/*        viewBox="0 0 13 13"*/}
          {/*        fill="none"*/}
          {/*        xmlns="http://www.w3.org/2000/svg"*/}
          {/*      >*/}
          {/*        <path*/}
          {/*          d="M4.7572 11.8641C4.7572 12.4164 5.20492 12.8641 5.7572 12.8641H6.8232C7.37549 12.8641 7.8232 12.4164 7.8232 11.8641V1.6001C7.8232 1.04781 7.37549 0.600098 6.8232 0.600098H5.7572C5.20492 0.600098 4.7572 1.04781 4.7572 1.6001V11.8641ZM0.158203 11.8641C0.158203 12.4164 0.605918 12.8641 1.1582 12.8641H2.2242C2.77649 12.8641 3.2242 12.4164 3.2242 11.8641V7.7321C3.2242 7.17981 2.77649 6.7321 2.2242 6.7321H1.1582C0.605918 6.7321 0.158203 7.17981 0.158203 7.7321V11.8641ZM10.3562 4.4326C9.80392 4.4326 9.3562 4.88031 9.3562 5.4326V11.8641C9.3562 12.4164 9.80392 12.8641 10.3562 12.8641H11.4222C11.9745 12.8641 12.4222 12.4164 12.4222 11.8641V5.4326C12.4222 4.88031 11.9745 4.4326 11.4222 4.4326H10.3562Z"*/}
          {/*          fill="#F87A55"*/}
          {/*        />*/}
          {/*      </svg>*/}
          {/*      查看评分*/}
          {/*    </Button>*/}
          {/*  }*/}
          {/*>*/}
          {/*  {productionAbilityLockCardState !== 'empty' &&*/}
          {/*  storeAbilityLockCardState !== 'empty' &&*/}
          {/*  brandLockState !== 'unlocked' ? (*/}
          {/*    <LockedCard*/}
          {/*      conBrandId={conBrandId}*/}
          {/*      className={styles.miniLockedCard}*/}
          {/*      mini*/}
          {/*      backgroundImgUrl="//assets-oss.cbndata.com/cbndata-refactor-fe/FgANQfQ_84y-ChoXLEcoUq1sMa68.png"*/}
          {/*      state={brandLockState as LockCardState}*/}
          {/*      onStateChange={onStateChange}*/}
          {/*    />*/}
          {/*  ) : (*/}
          {/*    <div className={styles.supplyChartContent}>*/}
          {/*      <InfoCard*/}
          {/*        className={styles.supplyInfoCard}*/}
          {/*        iconXLinkHref="#icon-automation"*/}
          {/*        title="自主生产能力"*/}
          {/*        info={*/}
          {/*          productionAbilityLockCardState === 'empty' ? (*/}
          {/*            <Button className={styles.supplyBtn} type="primary" onClick={onSupplyInfoBtnClick}>*/}
          {/*              补充信息*/}
          {/*            </Button>*/}
          {/*          ) : !supplyChain?.selfFactoryNum ? (*/}
          {/*            <span className={styles.emptyStateText}>暂无数据</span>*/}
          {/*          ) : (*/}
          {/*            <span className={styles.supplyNum}>{supplyChain?.selfFactoryNum}</span>*/}
          {/*          )*/}
          {/*        }*/}
          {/*      />*/}
          {/*      <InfoCard*/}
          {/*        className={styles.supplyInfoCard}*/}
          {/*        iconXLinkHref="#icon-storage"*/}
          {/*        title="仓储能力"*/}
          {/*        info={*/}
          {/*          storeAbilityLockCardState === 'empty' ? (*/}
          {/*            <Button className={styles.supplyBtn} type="primary" onClick={onSupplyInfoBtnClick}>*/}
          {/*              补充信息*/}
          {/*            </Button>*/}
          {/*          ) : !supplyChain?.storeNum ? (*/}
          {/*            <span className={styles.emptyStateText}>暂无数据</span>*/}
          {/*          ) : (*/}
          {/*            <span className={styles.supplyNum}>{supplyChain?.storeNum}</span>*/}
          {/*          )*/}
          {/*        }*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  )}*/}
          {/*</Chart>*/}
          <Chart
            title={
              <h2 className={styles.chartTitle}>
                物流配送效率
                <TooltipBase
                  title={
                    <>
                      <p>物流配送效率指品牌官方旗舰店物流服务评分。</p>
                      <p>数据来源：CBNData数据库</p>
                    </>
                  }
                  placement="right"
                />
              </h2>
            }
            panelClassName={styles.logisticsChart}
            className={classnames(styles.chartHeader, styles.logisticsChartHeader)}
          >
            <InfoCard
              iconXLinkHref="#icon-logistics"
              title="物流服务"
              className={styles.logisticsCard}
              info={
                <div className={styles.drsContent}>
                  {!dsrValue || dsrValue === '0.0' ? (
                    <span className={styles.emptyStateText}>暂无数据</span>
                  ) : (
                    <>
                      <span className={styles.drs}>{dsrValue}</span>
                      {/* <span className={styles.drsText}>持平于同行</span> */}
                    </>
                  )}
                </div>
              }
            />
          </Chart>
        </div>
      </>
    )
  );
};

export default memo(SupplyChainManagementAbility);
